module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(1), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_FISICA') ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_JURIDICA') ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_FISICA') ? _c('li', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_FISICA') ? _c('li', [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_JURIDICA') ? _c('li', [_vm._m(8)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_dados_consulta"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.resultado.cabecalho.protocoloTransacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cabecalho.consulta))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cabecalho.entrada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cabecalho.dataHora))])])])])])])]), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_FISICA') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_dados_pessoais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.cpf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.sexo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.dataNascimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.idade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.grauInstrucao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.maeNome))])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_JURIDICA') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_dados_empresa"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.razaoSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.nomeFantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.cnaeDescricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.porteEmpresa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resultado.cadastro.dataAbertura))])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_enderecos"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.enderecos), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.tipoLogradouro) + " " + _vm._s(item.logradouro))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.complemento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bairro))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.uf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cep))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_telefones"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', [(_vm.resultado.telefones != null && _vm.resultado.telefones.fixos != null) ? _vm._l((_vm.resultado.telefones.fixos), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.telefone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.operadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.relacao))]), _vm._v(" "), _c('td', _vm._l((item.tags), function(tag) {
      return _c('span', [_vm._v(_vm._s(tag))])
    }))])
  }) : _vm._e(), _vm._v(" "), (_vm.resultado.telefones != null && _vm.resultado.telefones.moveis != null) ? _vm._l((_vm.resultado.telefones.moveis), function(item) {
    return (_vm.resultado.telefones.moveis) ? _c('tr', [_c('td', [_vm._v(_vm._s(item.telefone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.operadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.relacao))]), _vm._v(" "), _c('td', _vm._l((item.tags), function(tag) {
      return _c('span', [_vm._v(_vm._s(tag))])
    }))]) : _vm._e()
  }) : _vm._e()], 2)])])])]), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_FISICA') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_ocupacoes"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.rendaEmpregador), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.documentoEmpregador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.empregador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.setorEmpregador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cboDescricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rendaEstimada) + " (" + _vm._s(item.faixaRenda) + ")")])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_FISICA') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_sociedades"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.participacoesEmpresas), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.documento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.qualificacaoSocio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.participacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dataEntrada))])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.resultado.cabecalho.consulta == 'PESSOA_JURIDICA') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_socios"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.quadroSocietario), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.documento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.qualificacaoSocio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.participacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dataEntrada))])])
  }))])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('b', [_vm._v("Resultado da Consulta Analítica")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_dados_consulta",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" Dados da Consulta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab_dados_pessoais",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Dados Pessoais")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab_dados_empresa",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" Dados da Empresa")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#tab_enderecos",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Localização")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#tab_telefones",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" Telefones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab_ocupacoes",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" Ocupações")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab_sociedades",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" Sociedades")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab_socios",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Sócios")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {}, [_c('th', [_vm._v("Protocolo")]), _vm._v(" "), _c('th', [_vm._v("Consulta")]), _vm._v(" "), _c('th', [_vm._v("Documento")]), _vm._v(" "), _c('th', [_vm._v("Data da Consulta")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Sexo")]), _vm._v(" "), _c('th', [_vm._v("Dt. Nasc")]), _vm._v(" "), _c('th', [_vm._v("Idade")]), _vm._v(" "), _c('th', [_vm._v("Escolaridade")]), _vm._v(" "), _c('th', [_vm._v("Nome da Mãe")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("CNPJ")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Fantasia")]), _vm._v(" "), _c('th', [_vm._v("Descrição CNAE")]), _vm._v(" "), _c('th', [_vm._v("Porte")]), _vm._v(" "), _c('th', [_vm._v("Data de Abertura")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("CEP")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Operadora")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Relação")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Tags")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("CNPJ")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Área de Atuação")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), _c('th', [_vm._v("Faixa Salarial")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("CNPJ")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), _c('th', [_vm._v("Participação (%)")]), _vm._v(" "), _c('th', [_vm._v("Sócio Desde")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Documento")]), _vm._v(" "), _c('td', [_vm._v("Nome")]), _vm._v(" "), _c('td', [_vm._v("Cargo")]), _vm._v(" "), _c('td', [_vm._v("Participação (%)")]), _vm._v(" "), _c('td', [_vm._v("Sócio desde")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16e05788"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consulta/ResultadoAnalitica.vue
// module id = 159
// module chunks = 1